/* app/ui/listing/operator */

define(
	'app/ui/listing/search-results',[
		'jquery',
		'util/core',
		'app/ui/listing/pagination',
		'pubsub'
	],
	function ($, Core, Pagination) {

		var Module;
		var queryObj = {};

		var $listingContainer;
		return {
			init: function($elms) {

				Module = this;

				$listingContainer = $elms.eq(0);
				Pagination.init($listingContainer);

				queryObj = Core.getQueryStringObject();

				// Remove "page" param
				queryObj.queryString = queryObj.queryString.replace(/(^|&)page=.*?(&|$)/, '$1');
				
				$.subscribe('/pagination/update', Module._onPaginationUpdate);
			},

			_onPaginationUpdate: function (pagingData) {

				console.log(pagingData);

				window.location = window.location.pathname + '?' + queryObj.queryString + '&page=' + pagingData.currentPage;
			}
		};
	}
);
